import {
  APP_CATEGORY_APPOINTMENT_SCHEDULING,
  APP_CATEGORY_BILLING_OPTIMIZATION,
  APP_CATEGORY_CARE_MANAGEMENT,
  APP_CATEGORY_CHECKIN_SOLUTIONS,
  APP_CATEGORY_CLINICAL_DECISION__SUPPORT,
  APP_CATEGORY_COMPLIANCE_AND_SECURITY,
  APP_CATEGORY_IMAGING_AND_DOCUMENT_MANAGEMENT,
  APP_CATEGORY_INVENTORY_MANAGEMENT,
  APP_CATEGORY_MEDICATION_AND_PRESCRIPTIONS,
  APP_CATEGORY_PATIENT_ACQUISITION_AND_ENGAGEMENT,
  APP_CATEGORY_PATIENT_EDUCATION,
  APP_CATEGORY_PRECISION_MEDICINE,
  APP_CATEGORY_SPECIALTY_SOLUTIONS,
  APP_CATEGORY_TELEHEALTH,
  APP_CATEGORY_VALUE_BASED_REIMBURSEMENT_SUPPORT,
  APP_CATEGORY_VOICE_RECOGNITION,
  APP_CATEGORY_WORKFLOW_EFFICIENCY,
} from '@developer/portal/constants';

export const appCategoriesArr = [
  APP_CATEGORY_APPOINTMENT_SCHEDULING,
  APP_CATEGORY_PATIENT_ACQUISITION_AND_ENGAGEMENT,
  APP_CATEGORY_VOICE_RECOGNITION,
  APP_CATEGORY_VALUE_BASED_REIMBURSEMENT_SUPPORT,
  APP_CATEGORY_TELEHEALTH,
  APP_CATEGORY_SPECIALTY_SOLUTIONS,
  APP_CATEGORY_PRECISION_MEDICINE,
  APP_CATEGORY_PATIENT_EDUCATION,
  APP_CATEGORY_MEDICATION_AND_PRESCRIPTIONS,
  APP_CATEGORY_BILLING_OPTIMIZATION,
  APP_CATEGORY_INVENTORY_MANAGEMENT,
  APP_CATEGORY_IMAGING_AND_DOCUMENT_MANAGEMENT,
  APP_CATEGORY_COMPLIANCE_AND_SECURITY,
  APP_CATEGORY_CLINICAL_DECISION__SUPPORT,
  APP_CATEGORY_CHECKIN_SOLUTIONS,
  APP_CATEGORY_CARE_MANAGEMENT,
  APP_CATEGORY_WORKFLOW_EFFICIENCY,
];

export const appCategoriesOptions = appCategoriesArr.map((el) => ({
  name: el,
  value: el,
}));
